const conveniosPaciente = [
  {
    id: 1,
    label: '4) Convênio do paciente',
    name: 'convenio_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Operadoras de saúde',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Particular',
        value: '2',
      },
      {
        id: 3,
        descricao: 'SUS',
        value: '3',
      },
    ],
  },
];

const tempoInicioSintomas = [
  {
    id: 1,
    label: 'Data do início dos sintomas',
    name: 'sintomas_data_sca',
  },
  {
    id: 2,
    label: 'Hora do início dos sintomas',
    name: 'sintomas_hora_sca',
  },
];

const outraInstituicao = [
  {
    id: 1,
    label:
      '6) Paciente proveniente de outra instituição',
    name: 'outra_instituicao_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];


const dataHoraChegada = [
  {
    id: 1,
    label: 'Data da chegada na instituição',
    name: 'entrada_data_sca',
  },
  {
    id: 2,
    label: 'Hora da chegada na instituição',
    name: 'entrada_hora_sca',
  },
];

const dataHoraEletro = [
  {
    id: 1,
    label: 'Data da realização do primeiro eletrocardiograma na instituição',
    name: 'ecg_data_sca',
  },
  {
    id: 2,
    label: 'Hora da realização do primeiro eletrocardiograma na instituição',
    name: 'ecg_hora_sca',
  },
];
const classificacaoSca = [
  {
    id: 1,
    label: '9) Classificação da SCA',
    name: 'classificacao_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'IAM com supradesnivelamento do segmento ST ou equivalente*',
        value: '1',
      },
      {
        id: 2,
        descricao: 'IAM sem supradesnivelamento do segmento ST',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Angina instável',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Suspeita não-confirmada de SCA',
        value: '4',
      },
    ],
  },
];

const situacaoAdmissao = [
  {
    id: 1,
    label: '10) Frequência cardíaca/pulso na admissão (bpm)',
    name: 'fc_sca',
  },
  {
    id: 2,
    label: '11) Pressão arterial sistólica na admissão (mmHg)',
    name: 'pas_sca',
  },
  {
    id: 3,
    label: '12) Creatinina sérica na admissão (mg/dL)',
    name: 'creatinina_sca',
  },
];

const dadosSca = [
  {
    id: 1,
    label:
      '13) Parada cardiorrespiratória relacionada ao quadro atual (do início dos sintomas até a admissão hospitalar)',
    name: 'pcr_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: '14) Alteração de marcadores de lesão cardíaca (troponina ou CK-MB)',
    name: 'enzimas_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: '15) Classificação de Killip',
    name: 'killip_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'I - Sem sinais de insuficiência cardíaca',
        value: '1',
      },
      {
        id: 2,
        descricao: 'II - Estertores pulmonares e/ou turgência venosa jugular',
        value: '2',
      },
      {
        id: 3,
        descricao: 'III - Edema pulmonar',
        value: '3',
      },
      {
        id: 4,
        descricao: 'IV - Choque cardiogênico',
        value: '4',
      },
    ],
  },
];


const tratamentoRealizado = [
  {
    id: 1,
    label: `17) Tratamento realizado`,
    name: 'tto_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Nenhum',
        value: '0',
      },
      {
        id: 2,
        descricao: 'Terapia fibrinolítica',
        value: '1',
      },
      {
        id: 3,
        descricao: 'Angioplastia primária',
        value: '2',
      },
      {
        id: 4,
        descricao: 'Cirurgia de revascularização miorcárdica',
        value: '3',
      },
      {
        id: 5,
        descricao: 'Angioplastia não primária',
        value: '4',
      },
      {
        id: 6,
        descricao: 'Paciente sem indicação de reperfusão',
        value: '98',
      },
    ],
  },
]

const eletrocardiograma = [
  {
    id: 1,
    label: `16) Eletrocardiograma com desvio do segmento ST`,
    name: 'st_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  }
]

const fracaoDeEjecao = [
  {
    id: 1,
    label: `20) Fração de ejeção do ventrículo esquerdo em exame realizado durante a internação`,
    name: 'fe_sca',
  }
]

const paliativos = [
  {
    id: 1,
    label: `21) Paciente em medidas de conforto ou cuidados paliativos`,
    name: 'paliativos_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  }
]

const motivoSaida = [
  {
    id: 1,
    label: '23) Motivo da saída hospitalar',
    name: 'saida_motivo_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Alta médica',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Óbito',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Transferência',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Evasão',
        value: '4',
      },
    ],
  },
];

const saidaEmergencia = [
  {
    id: 1,
    label: 'Data da saída',
    name: 'saida_data_sca',
  },
  {
    id: 2,
    label: `Hora da saída`,
    name: 'saida_hora_sca',
  },
];

const medicacoesAlta = [
  {
    id: 1,
    label: 'a) Estatina',
    name: 'estatina_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao: 'Razão documentada para não prescrição de Estatina',
        value: '98',
      },
    ],
  },
  {
    id: 2,
    label: 'b) Betabloqueador',
    name: 'bb_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao: 'Razão documentada para não prescrição de BB',
        value: '98',
      },
    ],
  },
  {
    id: 3,
    label: 'c) iECA/BRA',
    name: 'iecabra_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao: 'Razão documentada para não prescrição de iECA/BRA',
        value: '98',
      },
    ],
  },
];


const reinternacao = [
  {
    id: 1,
    label:
      '26) Paciente reinternou em até 30 dias após a saída da instituição',
    name: 'reinternacao_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ]
  }
]

const reinternacaoMotivo = [
  {
    id: 1,
    label: '27) Reinternação foi por motivo relacionado à SCA',
    name: 'reinternacao_motivo_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ]
  },
]

const terapiaFibrinolitica = [
  {
    id: 1,
    label: 'Data da realização da terapia fibrinolítica',
    name: 'fibrinolitico_data_sca',
  },
  {
    id: 2,
    label: `Hora da realização da terapia fibrinolítica`,
    name: 'fibrinolitico_hora_sca',
  },
];

const angioplastia = [
  {
    id: 1,
    label: 'Data da realização da angioplastia',
    name: 'angioplastia_data_sca',
  },
  {
    id: 2,
    label: `Hora da realização da angioplastia`,
    name: 'angioplastia_hora_sca',
  },
];

const covidSca = [
  {
    id: 1,
    label: '22) Paciente teve diagnóstico de COVID-19 durante a internação',
    name: 'covid_sca',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao:
          'Não testado',
        value: '2',
      },
    ],
  },
]


export {
  conveniosPaciente,
  tempoInicioSintomas,
  outraInstituicao,
  dataHoraChegada,
  dataHoraEletro,
  classificacaoSca,
  situacaoAdmissao,
  dadosSca,
  motivoSaida,
  eletrocardiograma,
  saidaEmergencia,
  medicacoesAlta,
  reinternacao,
  paliativos,
  reinternacaoMotivo,
  terapiaFibrinolitica,
  angioplastia,
  fracaoDeEjecao,
  tratamentoRealizado,
  covidSca,
};
